/* unplugin-vue-components disabled */import { render } from "./UserJob.vue?vue&type=template&id=22f4deb8&scoped=true"
import script from "./UserJob.vue?vue&type=script&lang=js"
export * from "./UserJob.vue?vue&type=script&lang=js"

import "./UserJob.vue?vue&type=style&index=0&id=22f4deb8&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/mianjuyry-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22f4deb8"]])

export default __exports__